import {OnBoardingTooltipModel} from "../on-boarding-tooltip.model";
import {IOnBoardingTooltipsContainer} from "../on-boarding-tooltips-container.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {makeObservable, observable, reaction, runInAction} from "mobx";
import {DomEventSubscription} from "../../../../../utils/event-listener-registration";
import {
    ExplorerOnboardingTooltip
} from "../../../../components/tooltip/tooltips/explorer-onboarding-tooltip/explorer-onboarding.tooltip";
import {ITooltipStyling} from "../../tooltip-base/tooltip-options.interface";
import {stickOnTopTooltipModifier} from "../../tooltip-base/tooltip-modifiers";

export class VideoSlidesExplorerOnBoardingTooltipModel extends OnBoardingTooltipModel {
    private _onScrollSubscription: DomEventSubscription | null = null;

    get styling(): ITooltipStyling | undefined {
        return {
            backgroundColor: 'transparent',
            borderColor: 'transparent'
        }
    }

    constructor(tooltipsContainer: IOnBoardingTooltipsContainer,
        services: IServiceFactoryExtended) {

        super(tooltipsContainer, services, {
            renderContent: () => {
              return (
                  <ExplorerOnboardingTooltip closeTooltipCallback={this.closeTooltip.bind(this)}/>
              )
            },
            placement: "bottom",
            modifiers: [stickOnTopTooltipModifier],
            localStorageKey: 'video_slides_onboarding_explorer_tooltip',
            maximumDisplayCount: 1,
            hasGlow: false,
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
            hasOwnStyle: true,
        });

        makeObservable(this);

        reaction(() => this.services.user.isAuthorized, (isAuthorized) => {
            if (isAuthorized && !this._onScrollSubscription) {
                // set a scroll event listener because the onboarding should be shown after user start's scrolling, once authenticated
                this._onScrollSubscription = this.services.window.subscribeTo.scroll(this._onWindowScroll);
            }
        }, {
            fireImmediately: true
        });
    }

    @observable.ref
    scrollDetected: boolean = false;

    private _onWindowScroll = () => {
        // Check if this.services.routing.currentRoute?.data?.arenaType because we show onboarding only for home page and arenas
        if (this.services.routing.currentRoute?.isOrbitRoute && this.services.window.scrollY > 200) {
            runInAction(() => {
                this.scrollDetected = true;
            });
        }
    };

    private _removeScrollSubscription = () => {
        // remove scroll event listener
        if (this._onScrollSubscription) {
            this._onScrollSubscription.dispose();
            this._onScrollSubscription = null;
        }
    };

    shouldDisplay(): boolean {
        const commonConditions = super.shouldDisplay();
        const videoSlidesShouldBeDisplayed = this.services.videoSlides.shouldBeDisplayed;
        const isFirstLoginAfterRegistration = this.services.sdk.isLoginFromRegistration;

        return !isFirstLoginAfterRegistration && commonConditions && videoSlidesShouldBeDisplayed && this.scrollDetected;
    }

    protected _getElementToAttach(): HTMLElement | null {
        return null;
    }

    onToolTipRendered(tooltipContainer: HTMLElement): void {
        super.onToolTipRendered(tooltipContainer);

        this._removeScrollSubscription();

        this.services.analytics.sendOrbitUserFlowEvent("Tooltip", "Show", "TT_Bubble");
    }
}